import { Link } from "react-router-dom";
import { ArrowRight, Phone, ShieldCheck, Award, Sparkles } from "lucide-react";
import { BRAND, IMAGES } from "../data/content";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center pt-24 pb-16 overflow-hidden"
    >
      {/* BG Image */}
      <div className="absolute inset-0 z-0">
        <img src={IMAGES.hero} alt="Maison rénovée en Alsace" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
      </div>

      {/* Ambient glow */}
      <div className="blob z-0" style={{ background: "#7DD923", width: 500, height: 500, top: -100, right: -150, opacity: 0.18 }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <div className="max-w-3xl">
          <div className="eyebrow fade-up flex items-center gap-2">
            <Sparkles className="w-3.5 h-3.5" /> Votre partenaire rénovation en {BRAND.region.split("·")[0].trim()}
          </div>
          <h1
            data-testid="hero-title"
            className="font-display uppercase text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-5 leading-[0.95] tracking-tight fade-up d1"
          >
            Réduisez vos<br/>
            <span className="text-[#7DD923]">factures</span> avec<br/>
            des solutions<br/>
            performantes
          </h1>
          <p className="text-white/70 text-lg md:text-xl mt-6 max-w-xl leading-relaxed fade-up d2">
            Pompes à chaleur, climatisation, isolation. Nous montons vos dossiers MaPrimeRénov' & CEE de A à Z pour financer jusqu'à <span className="text-[#7DD923] font-semibold">90% de votre projet</span>.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-8 fade-up d3">
            <Link to="/devis" data-testid="hero-cta-devis" className="btn-primary">
              Obtenir mon étude gratuite <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/contact#rappel" data-testid="hero-cta-rappel" className="btn-secondary">
              <Phone className="w-4 h-4" /> Être rappelé
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap gap-6 fade-up d4">
            {[
              { icon: ShieldCheck, label: "Certifié RGE" },
              { icon: Award, label: "QualiPAC · Qualibat" },
              { icon: Sparkles, label: "Étude gratuite < 48h" },
            ].map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2 text-white/70 text-sm">
                <div className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                  <Icon className="w-4 h-4 text-[#7DD923]" />
                </div>
                {label}
              </div>
            ))}
          </div>
        </div>

        {/* Floating stat card */}
        <div className="hidden lg:block absolute right-10 bottom-24 fade-up d3">
          <div className="glass rounded-2xl p-6 max-w-xs">
            <div className="text-xs uppercase tracking-[0.25em] text-[#7DD923] font-bold">Aides cumulées</div>
            <div className="font-display text-5xl text-white mt-2">11 000 €</div>
            <div className="text-white/60 text-sm mt-1">Aide moyenne pour une pompe à chaleur air/eau · foyer modeste.</div>
            <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between">
              <div className="flex -space-x-2">
                {[1,2,3].map(i => (
                  <div key={i} className="w-7 h-7 rounded-full bg-gradient-to-br from-[#7DD923] to-[#65B31B] border-2 border-black" />
                ))}
              </div>
              <div className="text-xs text-white/60">+320 clients Alsace</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom marquee */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/5 bg-black/60 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex flex-wrap items-center justify-between gap-4">
          <div className="text-xs uppercase tracking-[0.25em] text-white/40">Aides financières disponibles</div>
          <div className="flex flex-wrap gap-4 text-xs text-white/70">
            <span>MaPrimeRénov'</span>
            <span className="text-[#7DD923]">·</span>
            <span>CEE</span>
            <span className="text-[#7DD923]">·</span>
            <span>Éco-PTZ</span>
            <span className="text-[#7DD923]">·</span>
            <span>Aides locales Alsace</span>
          </div>
        </div>
      </div>
    </section>
  );
}
